import { Card, CardOptions } from "./card";

export class NewsFeed extends Card {
  constructor(element: HTMLElement, options: CardOptions) {
    super(element, options);
  }
}

export default function newsFeedInit() {
  const newsFeedCards = document.querySelectorAll(
    ".news-feed__card"
  ) as NodeListOf<HTMLElement>;
  for (let i = 0; i < newsFeedCards.length; i++) {
    new NewsFeed(newsFeedCards[i], {
      clickable: true,
      ctaClass: "news-feed__card-link",
    });
  }
}
